import type { AdminFormRequest } from './type';

export const defaultAdminForm: AdminFormRequest = {
  email: '',
  gender: '',
  phone: '',
  password: '',
  institutionId: '',
  firstName: '',
  lastName: '',
  avatar: '',
};
